/**
 * This component is provide the Select One Choice (dropdown) component
 * Its a resuable component used across the application for dropdown field
 */
import React from 'react';
import { Field } from 'redux-form';
import HookFormField from 'spark-ui/form/hookFormAdapter';
import Select from 'material-ui/Select';
import classes from './Select.css';

const menuPropsForEnterpriseDropdown = {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    getContentAnchorEl: null,
  }

const Dropdown = props => {
    const {
        label,
        disabled,
        input,
        options,
        renderOption,
        meta: { touched, error },
        multiple,
        isEnterprise,
        addEnterprise,
        open
    } = props;
    //first block is for enterprise dropdown
    if(isEnterprise){
        return (
            <Select
                className={ classes.selectDropdown}
                inputProps={input}
                disabled={disabled}
                multiple={multiple}
                disableUnderline="true"
                MenuProps= {isEnterprise ? menuPropsForEnterpriseDropdown: null}
                open={open}
            >
                {options.map(option => renderOption(option))}
            </Select>
        );
    } else {
        return (
            <div>
                <label>{label}</label>
                <Select
                    className={addEnterprise ? classes.selectDomain : isEnterprise ? classes.selectDropdown : classes.selectMenu}
                    inputProps={input}
                    disabled={disabled}
                    multiple={multiple}
                    disableUnderline="true"
                >
                    {options.map(option => renderOption(option))}
                </Select>
                <div className={classes.textHelp}>{touched && error}</div>
            </div>
        );
    }
    
};

const SelectField = (props) => {
    const { control, ...rest } = props;
    if (control) {
        return <HookFormField {...rest} control={control} component={Dropdown} />;
    }
    return <Field {...rest} component={Dropdown} />;
};

export { Dropdown };
export default SelectField;
